<template>
  <div
    class="errorDiv"
    :class="{
      'icj-required': isRequired,
      'icj-required-valid': isRequired && !error,
      'icj-error': error,
    }"
    :id="'itemId' + id + index"
  ></div>
  <div class="block p-5" :class="{ 'mb-5 bg-coral-light': errorMessage }">
    <div class="flex items-center flex-wrap">
      <div class="text-gray-92 leading-4 font-semibold mb-2">
        {{ itemName }}
        <span v-if="inputQuestion" class="text-xs ml-1"
          >- {{ inputQuestion }}</span
        >
        <span
          v-if="isRequired"
          class="ml-2"
          style="color: #de2d2d; font-size: 11px"
        >
          必須
        </span>
      </div>
    </div>
    <div v-if="description" class="text-xs my-2 text-gray-62">
      {{ description }}
    </div>
    <div
      v-if="ruleItems.max"
      class="text-xs font-light text-right text-gray-62"
    >
      上限あと{{ ruleItems.max - String(inputValueModel).length }}字
    </div>
    <div>
      <label class="flex items-center">
        <input
          type="text"
          class="block px-4 py-3 font-light border rounded leading-4"
          :class="[
            errorMessage ? 'border-danger' : 'border-gray-38',
            unit ? '' : 'min-w-full',
          ]"
          :maxlength="ruleItems.max || 1000"
          :placeholder="placeholder"
          :disabled="disabled"
          v-model="inputValueModel"
        />
        <span v-if="unit" class="ml-2">{{ unit }}</span>
      </label>
      <div v-if="errorMessage" class="text-danger text-xs mt-2">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue';
import validateRules from '@/utils/validateRules.js';

export default {
  props: {
    id: Number,
    itemName: String,
    inputQuestion: String,
    description: String,
    rules: String,
    unit: String,
    placeholder: String,
    inputValue: [Number, String],
    dataType: String,
    disabled: Boolean,
    isSubmit: Boolean,
    index: Number,
  },
  emits: ['update:inputValue'],
  setup(props, { emit }) {
    const state = reactive({
      error: false,
      errorMessage: '',
    });

    let dataTypeRule = '';
    switch (props.dataType) {
      case 'integer':
        dataTypeRule = '|integer';
        break;
      case 'decimal':
        dataTypeRule = '|double';
        break;
      case 'date':
        dataTypeRule = '|date';
        break;
    }

    const ruleItems = {};
    if (props.rules) {
      props.rules.split('|').forEach((rule) => {
        if (rule) {
          const items = rule.split(':');
          ruleItems[items[0]] = items[1] || '';
        }
      });
    }

    const inputValueModel = computed({
      get: () => {
        const result = validateRules.validate(
          props.inputValue,
          props.rules + dataTypeRule
        );
        if (result === true) {
          state.error = false;
        } else {
          state.error = true;
          if (props.isSubmit) state.errorMessage = result;
        }
        return props.inputValue || '';
      },
      set: (value) => {
        emit('update:inputValue', value);
        const result = validateRules.validate(
          value,
          props.rules + dataTypeRule
        );
        if (result === true) {
          state.error = false;
          state.errorMessage = '';
        } else {
          state.error = true;
          state.errorMessage = result;
        }
      },
    });

    const isRequired = props.rules.indexOf('required') !== -1;

    return {
      ...toRefs(state),
      inputValueModel,
      ruleItems,
      isRequired,
    };
  },
};
</script>

<style lang="scss" scoped>
.errorDiv {
  position: absolute;
  top: -56px;
  left: 0;
}
</style>
